import { InjectionToken } from '@angular/core';

import { IThirdPartyScriptsConfig } from './lib/interfaces/scripts.config';

export const THIRD_PARTY_SCRIPTS_CONFIG_TOKEN =
  new InjectionToken<IThirdPartyScriptsConfig>('Third Party Scripts Config');
